export default __webpack_public_path__ + "static/2024_mb_esg-264454ae8b87010dd19038790100ea79.jpg";